import React from 'react'
import Media from 'react-media'
import Header from './components/header'

import Scene from './scene'
import SceneMobile from './scene-mobile'
// import SceneWX from './scene-wx'
// import vConsole from './vsconsole.js'



import { Route, Routes } from 'react-router-dom'
import './App.scss';

class App extends React.PureComponent {
  // const carco = require("@craco/craco");

  headerRef = React.createRef()
  state = {
    headerColor: ''
  }

  handleHeaderColorChange = (color) => {
    this.setState({
      headerColor: color
    })
  }

  handleToggleAudioPlay = (play) => {
    const { audioRef, musicRef } = this.headerRef.current

    if (!audioRef || !audioRef.current) return
    if (play) {
      audioRef.current.play()
    } else {
      audioRef.current.pause()
    }
    musicRef && musicRef.current.musicTrans(play)
  }

  setRootFontSize () {
    const clientWidth = window.innerWidth
    const rootFontSize = clientWidth > 1366 ? clientWidth / 1366 * 16 : 16
    document.documentElement.style.fontSize = rootFontSize + 'px'
  }

  componentDidMount() {
    this.setRootFontSize()

    window.addEventListener('resize', () => {
      this.setRootFontSize()
    })
  }

  getPage = (path) => {
    const { headerColor } = this.state

    if('en' === path){
      return <>
        <Header color={headerColor} ref={this.headerRef}
          toggleAudioTransPlay={this.handleToggleAudioPlay} language='en'
        />
        <Media query={{ maxWidth: 1000 }}>
          {isMobile =>
            isMobile
              ? <SceneMobile changeHeaderColor={this.handleHeaderColorChange}
                toggleAudioPlay={this.handleToggleAudioPlay} language='en' />
              : <Scene changeHeaderColor={this.handleHeaderColorChange}
                toggleAudioPlay={this.handleToggleAudioPlay} language='en' />
          }
        </Media>
      </>
    }else if('ch' === path){
      return <>
        <Header color={headerColor} ref={this.headerRef}
          toggleAudioTransPlay={this.handleToggleAudioPlay} language='ch'
        />
        <Media query={{ maxWidth: 1000 }}>
          {isMobile =>
            isMobile
              ? <SceneMobile changeHeaderColor={this.handleHeaderColorChange}
                toggleAudioPlay={this.handleToggleAudioPlay} language='ch' />
              : <Scene changeHeaderColor={this.handleHeaderColorChange}
                toggleAudioPlay={this.handleToggleAudioPlay} language='ch' />
          }
        </Media>
      </>
    }else if('wx' === path){
      return <>
        <Header color={headerColor} ref={this.headerRef}
          toggleAudioTransPlay={this.handleToggleAudioPlay} language='ch'
        />
        <Media query={{ maxWidth: 1000 }}>
          {isMobile =>
            isMobile
              ? <Scene changeHeaderColor={this.handleHeaderColorChange}
                toggleAudioPlay={this.handleToggleAudioPlay} language='ch' />
              : <Scene changeHeaderColor={this.handleHeaderColorChange}
                toggleAudioPlay={this.handleToggleAudioPlay} language='ch' />
          }
        </Media>
      </>
    }
  }

  render () {

     //const buildType = 'all'; //默认打包英文站
    const buildType = 'ch'; //打包中文普通站
    //let buildType = 'en'; //打包英文站
    // const buildType = 'wx'; //打包中文小程序站
    // if(process.env.NODE_ENV === 'en' || process.env.PUBLIC_URL === '/doc/cemoy-sv'){
    //   buildType= 'en'; //打包英文站
    // }else if(process.env.NODE_ENV === 'ch' || process.env.PUBLIC_URL === '/doc/cemoy-sv-ch') {
    //   buildType = 'ch'; //打包中文普通站
    // }


    return (
      <div>
        <Routes>
          <Route path='*' element={
              this.getPage('all'===buildType?'en':buildType)
            } />
          <Route path='/en' element={
              this.getPage('en')
          } />
          <Route path='/ch' element={
              this.getPage('ch')
          } />
          <Route path='/wx' element={
              this.getPage('wx')
          } />
        </Routes>


      </div>
    )
  }
}

export default App;
